// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__3yBh0","consentsList":"PatientConsents_consentsList__lVVP_","consentsListEmpty":"PatientConsents_consentsListEmpty__lvQhv"};